import { Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { PagePaths } from "@/admin/shared/constants";
import type { TranslationRow } from "../model/types";

export function VariantsCell({ translation }: { translation: TranslationRow }) {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {translation.variants.map((variant) => (
        <Button
          key={variant.languageCode}
          size="small"
          component={Link}
          to={`${PagePaths.translations}/${translation.id}/${variant.languageCode}`}
          variant={variant.untranslated > 0 ? "contained" : "outlined"}
          color={variant.untranslated > 0 ? "info" : "primary"}
        >
          {variant.languageCode} {variant.translated}/{variant.total}
        </Button>
      ))}
    </Stack>
  );
}
